import { OpenInNew } from '@mui/icons-material';
import React from 'react';

import CLocalizedTextStringStatic from '../../../../../components/CLocalizedTextStringStatic';
import CPageModule from '../../../../../components/CPageModule';
import CResponsiveGrid from '../../../../../components/CResponsiveGrid';
import { type IFundPortrait } from '../../../../../components/IFundPortrait';
import { BreakpointsInPx } from '../../../../../enums/BreakpointsInPx';
import { useAppSelector } from '../../../../../hooks/hooks';

interface Props {
  fundPortrait: IFundPortrait;
}

export default function CFactsheetOverviewContactInfo(props: Props) {
  const { dashboardOutletDimensions } = useAppSelector((state) => state.dashboard);
  const portfolioManagementLabel = CLocalizedTextStringStatic('fsovP8H1');
  const custodianLabel = CLocalizedTextStringStatic('fsovP6H1');
  const imcLabel = CLocalizedTextStringStatic('fsovP7H1');
  const fundInitiatorLabel = CLocalizedTextStringStatic('fsovP4H1');
  const aboutHeading = CLocalizedTextStringStatic('fsovP5H1');
  const aboutDesc = CLocalizedTextStringStatic('fsovP5Desc');
  const noteHeading = CLocalizedTextStringStatic('fsovP9H1');
  const noteDesc = CLocalizedTextStringStatic('fsovP9Desc');

  return (
    <>
      <CPageModule>
        <CResponsiveGrid
          maxColumns={3}
          style={{
            rowGap: '3rem',
            columnGap: '1.5rem'
          }}
        >
          <AddressCard label={portfolioManagementLabel} address={props.fundPortrait.portfolioManager} />
          <AddressCard label={custodianLabel} address={props.fundPortrait.custodian} />
          <AddressCard label={imcLabel} address={props.fundPortrait.investmentManagementCompany} />
          <AddressCard label={fundInitiatorLabel} address={props.fundPortrait.fundInitiator} />
          <div
            style={{
              gridColumn:
                dashboardOutletDimensions.w < BreakpointsInPx.BREAKPOINT_2 ? 'span 1 / span 1' : 'span 2 / span 2'
            }}
          >
            <CPageModule fullWidth style={{ paddingTop: 0, paddingBottom: 0 }}>
              <h3>{aboutHeading}</h3>
              <p>{aboutDesc}</p>
            </CPageModule>
          </div>
        </CResponsiveGrid>
      </CPageModule>
      <CPageModule>
        <h3>{noteHeading}</h3>
        <p>{noteDesc}</p>
      </CPageModule>
    </>
  );
}

function AddressCard(props: {
  label: string;
  address:
    | IFundPortrait['portfolioManager']
    | IFundPortrait['investmentManagementCompany']
    | IFundPortrait['fundInitiator']
    | IFundPortrait['custodian'];
}) {
  return (
    <CPageModule fullWidth style={{ paddingTop: 0, paddingBottom: 0 }}>
      <h3>{props.label}</h3>
      <p>
        <span>{props.address.name}</span>
        <br />
        {props.address.addressLine2 && (
          <>
            <span>{props.address.addressLine2}</span>
            <br />
          </>
        )}
        <span>{props.address.addressLine1}</span>
        <br />
        <span>
          {props.address.postalCode} {props.address.city}
        </span>
        <br />
        <span>{props.address.country}</span>
        <br />
        {props.address.url && (
          <>
            <a href={props.address.url} target={'_blank'} rel={'noreferrer'}>
              {props.address.url.split('/').slice(0, 3).join('/')} <OpenInNew />
            </a>
          </>
        )}
      </p>
    </CPageModule>
  );
}
